exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".U2djb{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}.U2djb:hover{opacity:.7}._23H5Z{visibility:hidden !important;width:0 !important;min-width:0 !important;height:0 !important;min-height:0 !important;margin:0 !important;padding:0 !important;opacity:0 !important}._1iTrx{position:absolute;z-index:10000;top:10px;left:10px;overflow:scroll;width:400px;height:250px;border-radius:3px;background-color:rgba(0,0,0,0.95)}._1iTrx ._1BJxb{position:absolute;top:10px;right:5px;cursor:pointer;color:white}._1iTrx ._1BJxb:hover{opacity:.8}._1iTrx ._2NA64{font-size:8px;line-height:8px;margin:5px;padding:5px;color:white}._1iTrx ._2NA64 ._3Q49S{color:green}._1iTrx ._2NA64 .oo0qa{color:darkorange}._1iTrx ._2NA64 ._9SgdT{color:blue}._1iTrx ._2NA64 ._2LY52{color:magenta}._1iTrx ._2NA64 ._33rV5{color:white}\n", ""]);

// Exports
exports.locals = {
	"controlButton": "U2djb",
	"hidden": "_23H5Z",
	"debugPanel": "_1iTrx",
	"closeButton": "_1BJxb",
	"infoContainer": "_2NA64",
	"string": "_3Q49S",
	"number": "oo0qa",
	"boolean": "_9SgdT",
	"null": "_2LY52",
	"key": "_33rV5"
};